import { render, staticRenderFns } from "./examresults.vue?vue&type=template&id=94035758&scoped=true"
import script from "./examresults.vue?vue&type=script&lang=js"
export * from "./examresults.vue?vue&type=script&lang=js"
import style0 from "./examresults.vue?vue&type=style&index=0&id=94035758&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94035758",
  null
  
)

export default component.exports